module.exports = __webpack_public_path__ + "static/media/promote_02.6306acfc.png";